// @flow
import React from 'react';

import SessionStatistics from './SessionStatistics';
import { useDispatch } from 'react-redux';

type Props = {
  rightResults: number,
  allResults: number,
  wrongResults: number,
  setGameResults: ([]) => void,
  isAdaptive: true,
}

const ResultStatistics = ({
  rightResults = 0,
  allResults = 0,
  wrongResults = 0,
  setGameResults,
  isAdaptive = false,
}: Props) => {
  const dispatch = useDispatch();
  // const isFreeUser = useSelector((state) => state.profile.free_access);
  const isFreeUser = localStorage.getItem('freeAccess') === 'true';

  const handleReset = async () => {
    if (await setGameResults([]) === false) return;
    dispatch({ type: 'RESET_GAME', payload: { isFreeUser } });
    dispatch({
      type: 'GET_MISTAKES_CLEAR',
      payload: {},
    });
  };

  return (
    <SessionStatistics
      rightResults={rightResults}
      allResults={allResults}
      wrongResults={wrongResults}
      onReset={handleReset}
      isAdaptive={isAdaptive}
    />
  );
};

export default ResultStatistics;
